import React, { useEffect, useState } from "react";
import styles from "./header.module.css";
import NavItem from "./nav-item/nav-item";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toggle as toggleTheme } from "../../store/reducers/toggle/themeToggle";
import { toggle as toggleLang } from "../../store/reducers/toggle/langToggle";
import FilterSelect from "../filter-select/filter-select";
import { LOCALES } from "../../constants";
import { loadData } from "../../functions/dataLoader";
import FILTERS from "../../config/filter_config.json";

export default function Header({ title, backTo }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isActive, setIsActive] = useState(false);
    // const [filters, setFilters] = useState(null);

    // useEffect(() => {
    //     loadData("filter_config.json").then(setFilters);
    // }, []);

    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);

    localStorage.setItem("theme", theme);
    localStorage.setItem("language", lang);

    const toggleNav = () => {
        setIsActive(!isActive);
    };

    const themeTitle = lang === LOCALES.KO ? "테마 변경" : "Change Theme";
    const langTitle = lang === LOCALES.KO ? "Change Language" : "Change Language";

    // if (!filters) return;

    return (
        <header id={styles["header-container"]}>
            <div className={styles["header"]}>
                <div className={styles["header-left"]}>
                    {backTo && (
                        <button className={styles["header-btn"]} title="뒤로가기" onClick={() => navigate(backTo)}>
                            <i className="fi fi-rr-arrow-left" />
                        </button>
                    )}
                    {!backTo && (
                        <div className={styles["hamburger-wrapper"]}>
                            <button className={styles["header-btn"]} title="메뉴" onClick={() => toggleNav()}>
                                <i className="fi fi-sr-menu-burger" />
                            </button>
                            <div className={`${styles["nav-dropdown"]} ${isActive ? `${styles["active"]}` : ""}`}>
                                <NavItem to={"savior"} />
                                <NavItem to={"arcana"} />
                                {/* <NavItem to={"deck"} /> */}
                                <NavItem to={"journey"} />
                                <NavItem to={"schedule"} />
                                <NavItem to={"gacha"} />
                                <NavItem to={"item"} />
                                <NavItem to={"monster"} />
                                <NavItem to={"potential"} />
                                {/* <NavItem to={"music"} /> */}
                                <NavItem to={"wallpaper"} />
                                <NavItem to={"simulator/savior"} />
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles["title"]}>{title}</div>
                <div className={styles["header-right"]}>
                    <div className={styles["toggle-group"]}>
                        <FilterSelect
                            id={""}
                            list={FILTERS.LANGUAGE}
                            selected={FILTERS.LANGUAGE.find((e) => e.value === lang)}
                            changeFilter={toggleLang}
                            forceSmallPadding={true}
                        />
                        {/* <button
                            className={styles["dark-light-toggle"]}
                            // aria-hidden="true"
                            title={langTitle}
                            onClick={() => dispatch(toggleLang())}
                            key={"toggle_lang_button"}
                        >
                            <div className={`${styles["icon30"]} ${styles["kor"]}`}>
                                <span>KO</span>
                            </div>
                            <div className={`${styles["icon30"]} ${styles["eng"]}`}>
                                <span>EN</span>
                                <span className="fi fi-us"></span>
                            </div>
                        </button> */}
                    </div>
                    <div className={styles["toggle-group"]}>
                        <button
                            className={styles["dark-light-toggle"]}
                            aria-hidden="true"
                            title={themeTitle}
                            onClick={() => dispatch(toggleTheme())}
                            key={"toggle_theme_button"}
                        >
                            <div className={`${styles["icon30"]} ${styles["sun"]}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#222222">
                                    <path d="M480-280q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Z" />
                                </svg>
                            </div>
                            <div className={`${styles["icon30"]} ${styles["moon"]}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
                                    <path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Z" />
                                </svg>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
}
